import { render, staticRenderFns } from "./laborer.vue?vue&type=template&id=06d34410&scoped=true"
import script from "./laborer.vue?vue&type=script&lang=js"
export * from "./laborer.vue?vue&type=script&lang=js"
import style0 from "./laborer.vue?vue&type=style&index=0&id=06d34410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d34410",
  null
  
)

export default component.exports